import { useLayoutEffect as e, useEffect as f } from "react";
import { isServer as o } from '../utils/ssr.js';
var s = o ? f : e;
export { s as useIsoMorphicEffect };